/**
 * @generated SignedSource<<ec030453baa08385e100211a2f818f50>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProviderApiKeyAddInput = {
  autoConfirmOrders: boolean;
  descriptionKey?: string | null;
  invitionPhoneNumber?: string | null;
  printfulPrefix?: string | null;
  printfulSuffix?: string | null;
  providerId: number;
  secretKey?: string | null;
};
export type providerQueryAddMutation$variables = {
  input: ProviderApiKeyAddInput;
};
export type providerQueryAddMutation$data = {
  readonly addApiKey: {
    readonly autoConfirmOrders: boolean;
    readonly clientId: number;
    readonly descriptionKey: string | null;
    readonly id: string;
    readonly invitionPhoneNumber: string | null;
    readonly printfulPrefix: string | null;
    readonly printfulSuffix: string | null;
    readonly providerId: number;
    readonly secretKey: string | null;
  } | null;
};
export type providerQueryAddMutation = {
  response: providerQueryAddMutation$data;
  variables: providerQueryAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProviderApiKeyDto",
    "kind": "LinkedField",
    "name": "addApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secretKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "descriptionKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "autoConfirmOrders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "printfulPrefix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "printfulSuffix",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invitionPhoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "providerQueryAddMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "providerQueryAddMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "4bc667e49a5466d17b7db6f17caf071d",
    "id": null,
    "metadata": {},
    "name": "providerQueryAddMutation",
    "operationKind": "mutation",
    "text": "mutation providerQueryAddMutation(\n  $input: ProviderApiKeyAddInput!\n) {\n  addApiKey(input: $input) {\n    providerId\n    secretKey\n    descriptionKey\n    autoConfirmOrders\n    clientId\n    id\n    printfulPrefix\n    printfulSuffix\n    invitionPhoneNumber\n  }\n}\n"
  }
};
})();

(node as any).hash = "334b9591643ae4d000549e51c1441206";

export default node;
